import { checkShellVersion } from '../../../utils';
import { TGetGenerateQRItem } from './interfaces';

export const getGenerateQrItem: TGetGenerateQRItem = ({
  permissions,
  openGenerateQrModal,
  selectedHostsIds,
  t,
}) => {
  return !permissions?.has('host_manage')
    ? null
    : {
        key: 'generateQr',
        text: t('host.ctx.generate_qr'),
        iconName: 'QRCodeIcon',
        onClick: openGenerateQrModal,
        disabled: ({ info }) =>
          checkShellVersion(info?.shell_version) ||
          !!(selectedHostsIds && selectedHostsIds.length > 1),
      };
};
